import { motion, AnimatePresence } from "motion/react";
import { useEffect, useState } from "react";
import { Logo } from "@stockuj/ui";

const MIN_DISPLAY_MS = 1200;

type SplashScreenProps = {
  isReady: boolean;
  onDismiss?: () => void;
};

export function SplashScreen({ isReady, onDismiss }: SplashScreenProps) {
  const [show, setShow] = useState(true);
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMinTimeElapsed(true), MIN_DISPLAY_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isReady && minTimeElapsed) {
      setShow(false);
    }
  }, [isReady, minTimeElapsed]);

  return (
    <AnimatePresence onExitComplete={onDismiss}>
      {show && (
        <motion.div
          className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-navy"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 200,
              damping: 22,
              delay: 0.1,
            }}
          >
            <motion.div
              animate={{ scale: [1, 1.04, 1] }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <Logo size={120} withSparkle />
            </motion.div>
          </motion.div>

          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
          >
            <div
              className="text-2xl font-bold text-white"
              style={{ fontFamily: "Geist, system-ui, sans-serif" }}
            >
              Stockuj
            </div>
            <div
              className="mt-2 uppercase text-accent"
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                letterSpacing: "4px",
              }}
            >
              Magazyn · na · autopilocie
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
